export default "__VITE_ASSET__ef9e6d47__"